<script>
import Merchandising from "@/services/Merchandising";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import modalAddTermsToAttribute from "../modals/merchandise/modalAddTermsToAttribute.vue";
export default {
  components: {Multiselect, modalAddTermsToAttribute},
  props: {
    product_id: String,
    category_id: String,
  },
  data() {
    return {
      productTags: [],
      availableAttributes: [],
      productTerms:[],
      availableTerms:[],
      selectedTerms: [],
      modalAttributeId:'',
      tags: [],
      showLoader: true,
      showButtonSpinner: false,
      selectedTermsByAttr: {},
    };
  },

  async mounted() {
    if (this.category_id) {
      await this.getAttributesByCategory();
    }
    if (this.product_id) {
      await this.getTermsForProduct();
    }


  },
  watch:{
    category_id: async function(){
      await  this.getAttributesByCategory();
    },
    product_id: async function(){
      await this.getTermsForProduct();
    }


  },

  methods: {
    openModalAddTermsToAttribute(id) {
      this.modalAttributeId = id;
      this.$bvModal.show("add_terms_to_attribute");
    },
    termsForAttribute(attr) {
      return this.productTerms.filter(term =>
          attr.terms.some(t => t.term_id === term.term_id)
      );
    },
    async addTermToProduct(attr) {
      const selectedTerms = this.selectedTermsByAttr[attr.attr_id] || [];
      try {
        const body = {
          prod_id: this.product_id,
          term_id: selectedTerms.map(t => t.term_id)[0],
        }
        const response = await Merchandising.addTermToProductMerch(body);
        if (response.status === 200) {
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: response.data.data.message,
            confirmButtonColor: "#5B73E7",
          });
          this.selectedTermsByAttr[attr.attr_id] = [];
          await this.getTermsForProduct();
          await this.getAttributesByCategory();
        } else {
          console.error("Error attaching terms:", response.data.data.message);
        }
      }catch (error){
        console.error("Error attaching terms:", error);
      }

    },
    async getAttributesByCategory() {
      try {
        this.showLoader = true;
        const response = await Merchandising.getAttributeByCategoryId(this.category_id);

        if (response.status === 200) {
          this.availableAttributes = response.data.data;
          this.availableTerms = this.availableAttributes.flatMap(attr => attr.terms);

        } else {
          console.error("Error fetching attributes:", response.data.data.message);
        }
      } catch (error) {
        console.error("Error fetching attributes:", error);
      }
      finally {
        this.showLoader = false;
      }
    },
    async getTermsForProduct() {
      try {
        this.showLoader = true;
        const response = await Merchandising.getTermsForProduct(this.product_id);
        if (response.status === 200) {
          this.productTerms = response.data.data;
        } else {
          console.error("Error fetching terms:", response.data.data.message);
        }
      } catch (error) {
        console.error("Error fetching terms:", error);
      }finally {
        this.showLoader = false;
      }
    },
    refreshData(){
      this.getAttributesByCategory()
      this.getTermsForProduct()
    },

    async unlinkTerm(id) {
      Swal.fire({
        title: "Unlink Term?",
        text: "This Term will be unlinked from this Product!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Unlink!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await Merchandising.removeProductTerm(id);
            if (response.data) {
              Swal.fire("Success!", "Term is successfully unlinked !", "success");
              await this.getTermsForProduct();
              await this.getAttributesByCategory();
            } else {
              let errorMessage = response.error ? response.error : 'Failed';
              if (typeof errorMessage === 'object') {
                errorMessage = errorMessage[0];
              }
              Swal.fire("Fail!", errorMessage, "warning");
            }
          } catch (error) {
            let errorMessage = error.response && error.response.data && error.response.data.error
                ? error.response.data.error
                : "An error occurred while unlinking term!";
            if (typeof errorMessage === 'object') {
              errorMessage = errorMessage[0];
            }
            Swal.fire("Error", errorMessage, "error");
          }
        }
      });
    },


  }
};
</script>
<template>
    <div>
       <div class="d-flex align-items-center gap-3">
         <p  class="mb-1 text-strong mb-1 font-size-18">Available Attributes</p>
       </div>
        <div v-if="showLoader" class="d-flex justify-content-center align-items-center">
          <span class="spinner-border text-primary" role="status"></span>
        </div>
        <div v-else class="d-flex flex-wrap mt-3">
          <div class="col-6"  v-for="attr in availableAttributes" :key="attr.attr_id">
            <div class="card py-3 d-flex align-items-center " style="height: 200px;">
              <div class="text-info fw-bold font-size-18 mb-1"> {{ attr.name }}</div>
              <div v-if="termsForAttribute(attr).length">
                <div v-for="term in termsForAttribute(attr)" :key="term.term_id" class="mb-2 d-flex flex-column justify-content-center align-items-center">
                  <span>This product is linked to the term {{ term.term_name }} <i @click="unlinkTerm(term.id)" title="Unlink this term" style="cursor:pointer;" class="uil uil-trash-alt text-danger font-size-18"></i></span>
                  To change the term first delete the existing one
                </div>
              </div>
              <div v-else class="mb-2">
                No linked terms found for this attribute <span @click="openModalAddTermsToAttribute(attr.attr_id)" class="text-primary fw-bold" style="cursor:pointer;">Add Term</span>
              </div>
              <b-form-group class="w-100 px-3 ">
                <multiselect  v-model="selectedTermsByAttr[attr.attr_id]"
                              :disabled="termsForAttribute(attr).length === 1"
                              label="term_name"
                             track-by="term_id"
                             placeholder="Type to search terms"
                             :multiple="true"
                             :options="attr.terms"
                             :searchable="true"
                             :loading="showLoader"
                             :internal-search="true"
                             :clear-on-select="false"
                             :close-on-select="false"
                             :options-limit="300"
                             :max-height="600"
                             :show-no-results="false"
                             :hide-selected="true">
                          <template slot="tag" slot-scope="{ option, remove }">
                            <span class="custom__tag">
                                <span>{{ option.term_name }}</span>
                                <span class="custom__remove" @click="remove(option)">✖</span>
                            </span>
                  </template>
                </multiselect>

              </b-form-group>
              <div class="w-100 d-flex align-items-end mt-3 justify-content-end px-3">
                <button :disabled="termsForAttribute(attr).length === 1" class="btn btn-primary" @click="addTermToProduct(attr)">Save
                </button>
              </div>
            </div>
          </div>
        </div>
      <modalAddTermsToAttribute @onRefresh="refreshData" :id="modalAttributeId"></modalAddTermsToAttribute>
    </div>
</template>

  
  
  
  
  
  